import { connect } from "nats.ws";
import { setConnected, setDisconnected, setError } from "slice/statusNatsSlice";
import store from "store";

let natsConnection = null;
const subscriptions = {};

// Fungsi untuk unsubscribe subscription yang sedang aktif
export const unsubscribeCurrent = () => {
  const previousSubs = localStorage.getItem("subs");
  if (previousSubs && subscriptions[previousSubs]) {
    subscriptions[previousSubs].unsubscribe();
    delete subscriptions[previousSubs];
    localStorage.removeItem("subs");
    console.log(`Unsubscribed from previous subject: ${previousSubs}`);
  }
};

export const connectToNats = async () => {
  if (!natsConnection) {
    try {
      natsConnection = await connect({
        servers: "wss://facereco.grit.id:9002",
        token: "my_secure_token_123",
        debug: false,
      });
      store.dispatch(setConnected());
      console.log("Connected to NATS!");

      natsConnection.closed().then(() => {
        console.log("Disconnected from NATS!");
        store.dispatch(setDisconnected());
      });
    } catch (error) {
      console.log(error, "error");
      store.dispatch(setError(error?.message));
      console.error("Failed to connect to NATS:", error);
    }
  }
  return natsConnection;
};

export const publishMessage = async (subject, data) => {
  try {
    const nc = await connectToNats();
    if (nc) {
      nc.publish(subject, new TextEncoder().encode(JSON.stringify(data)));
      console.log(`Published to ${subject}:`, data);
    }
  } catch (error) {
    console.error("Error publishing message:", error);
  }
};

export const subscribeMessage = async (subject, callback) => {
  try {
    const nc = await connectToNats();
    if (nc) {

      // Unsubscribe dulu sebelum subscribe baru
      // console.log("Unsubscribing previous subscription if exists...");
      // unsubscribeCurrent();

      // Baru subscribe ke kamera baru
      console.log(
        `%cSubscribed to ${subject}`,
        "color: green; font-weight: bold; font-size: 14px;"
      );
      const sub = nc.subscribe(subject);
      subscriptions[subject] = sub;
      localStorage.setItem("subs", subject);

      // console.log(`Subscribed successfully to ${subject}`);

      (async () => {
        for await (const msg of sub) {
          try {
            const messageData = new TextDecoder().decode(msg.data);
            callback(JSON.parse(messageData));
            // const parsedData = JSON.parse(messageData); // Jadikan object
            // console.log(
            //   `%cget data from to ${subject}`,
            //   "color: blue; font-weight: bold; font-size: 14px;"
            // );
            // console.log(
            //   `%c data from to ${parsedData}`,
            //   "color: black; font-weight: bold; font-size: 14px;"
            // );
            // console.log(parsedData, `data dari ${subject}`);
          } catch (error) {
            console.error("Error decoding message:", error);
          }
        }
      })();
    }
  } catch (error) {
    console.error("Error subscribing to message:", error);
  }
};

export const unsubscribeMessage = (subs) => {
  const sub = subscriptions[subs];
  if (sub) {
    sub.unsubscribe();
    delete subscriptions[subs];
    // localStorage.removeItem("subs");
    console.log(`%cUnsubscribe video ${subs}`, "color: red;");
  } else {
    console.warn(`No active subscription for subs: ${subs}`);
  }
};

// Optional, kalau mau cek yang sekarang lagi di-subscribe
export const subs = localStorage.getItem("subs");
